/* eslint-disable camelcase */
import Api from '../api';

export interface CustomAnalysisPromptResponse {
  id: number;
  content: string;
  created_at: string | null;
  updated_at: string | null;
}

export interface CustomAnalysisResponse {
  analysis_prompt: CustomAnalysisPromptResponse | null;
}

export interface ImproveCustomAnalysisResponse {
  prompt?: string;
  content?: string;
  improved_prompt?: string;
}

export const getCustomAnalysis = () =>
  Api.get<CustomAnalysisResponse>('/gestao_ia/analise_personalizada');

export const improveCustomAnalysis = (prompt: string) =>
  Api.post<ImproveCustomAnalysisResponse>('/gestao_ia/analise_personalizada/aprimorar', { prompt });

export const saveCustomAnalysis = (content: string) =>
  Api.post<CustomAnalysisResponse>('/gestao_ia/analise_personalizada', { content });

export const deleteCustomAnalysis = () => Api.delete('/gestao_ia/analise_personalizada');

export interface CustomAnalysisSearchResponse {
  status?: string;
  content?: string;
}

export const getCustomAnalysisResult = (biddingId: number) =>
  Api.post<CustomAnalysisSearchResponse>(
    `/gestao_ia/licitacoes/${biddingId}/analise_personalizada`,
  );

export const refreshCustomAnalysisResult = (biddingId: number) =>
  Api.post<CustomAnalysisSearchResponse>(
    `/gestao_ia/licitacoes/${biddingId}/analise_personalizada`,
    { force: true },
  );
